exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.status-cell span.label {\n  padding: 4px !important;\n  border-radius: 3px;\n  margin-left: 1px;\n  line-height: 20px;\n  height: 20px;\n}\ndiv.status-cell span.label i.material-icons {\n  font-size: 18px !important;\n}\n", ""]);

// exports
